import React from 'react';

import { Row } from 'xpi-black-ui/Base/Grid';
import Button from 'xpi-black-ui/Base/Button';
import Dialog, { DialogHeader, DialogContent } from 'xpi-black-ui/Common/Dialog';

import { Container, Header} from './styles';

const ModalDialog = (props) => {
  const { title, onClose, actionPrimaryButton, titleSecondaryButton, titlePrimaryButton, ...otherProps } = props;

  return (
    <Dialog {...otherProps} overlayClick={onClose} >
      <Header>
        <DialogHeader title={title} onClose={onClose} />
      </Header>
      <Container>
        <DialogContent description="">
          <Row justifyContent="space-around">
            <Button primary onClick={actionPrimaryButton}>{titlePrimaryButton}</Button>
            <Button secondary onClick={onClose}>{titleSecondaryButton}</Button>
          </Row>
        </DialogContent>
      </Container>
    </Dialog>
  );
};

export default ModalDialog;
